<template>
  <div class="container-fluid">
    <b-card no-body class="mt-3 mb-1">
      <b-card-header class="py-0 pl-0"
        ><b-card-body class="py-2">
          <b-row>
            <b-col xl="2" lg="3" md="3">
              <b-card-title class="card-title-doorder my-3"
                >History</b-card-title
              ></b-col
            >
            <b-col xl="10" lg="9" md="9" class="pr-0">
              <b-row class="justify-content-end filterContrainerDiv my-2">
                <b-col xl="5" lg="6" md="6" sm="8">
                  <b-form-group
                    class="
                      form-group-doorder form-group-datetime-filter-doorder
                      pb-0
                      m-0
                    "
                  >
                    <date-picker
                      v-model="date_range"
                      type="date"
                      value-type="YYYY-MM-DD"
                      format="DD MMM YYYY"
                      range
                      :disabled-date="disabledAfterToday"
                      :partial-update="true"
                      :confirm="false"
                      placeholder="Select date range"
                      popup-class="datetime-picker-doorder"
                      input-class="form-control form-control-filter-doorder w-100"
                    >
                      <template v-slot:icon-calendar
                        ><img
                          src="@/assets/images/doorder/calendar-filter-yellow.png"
                        />
                      </template>
                    </date-picker>
                  </b-form-group>
                </b-col>
                <b-col xl="2" lg="3" md="3" sm="4" class="px-md-1">
                  <b-button
                    variant="doorder-primary"
                    id=""
                    class="
                      btn-bumblebee btn-doorder btn-doorder-filter
                      my-0
                      w-100
                    "
                    @click="clickExport"
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-download"
                      class="mr-1"
                    />
                    Export
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card-header>
    </b-card>
    <b-overlay
      :show="overlay_show"
      rounded="sm"
      variant="doorder-primary"
      opacity="0.5"
      blur="2px"
    >
      <b-card>
        <b-table-simple
          class="table table-no-bordered table-hover doorderTable"
          id="ordersTable"
          hover
          responsive
        >
          <b-thead>
            <b-tr>
              <b-th>Date/Time</b-th>
              <b-th>Order Number</b-th>
              <!-- <b-th>Order Time</b-th> -->
              <b-th v-show="user_title == 'admin'">Retailer Name</b-th>
              <b-th>Deliverer</b-th>
              <b-th>Trip Route</b-th>
              <b-th>Status</b-th>
              <b-th class="text-center">Comments</b-th>
              <b-th class="text-center">Actions</b-th>
            </b-tr>
          </b-thead>
          <b-tbody> </b-tbody>
        </b-table-simple>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import $, { param } from "jquery";
import axios from "axios";
import { getOrderStatusClassAndStr } from "@/utils/helper-functions-doorder.js";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import RouteLocationPins from "../datatable_custom_cells/RouteLocationPins.vue";
import ItemStatus from "../datatable_custom_cells/ItemStatus.vue";
import Comment from "../datatable_custom_cells/Comment.vue";
import ViewOrder from "../datatable_custom_cells/ViewOrder.vue";

import Vue from "vue";

var table;
export default {
  name: "DoOrderOrdersHistoryList",
  components: { DatePicker },
  data() {
    return {
      client_name: "DOORDER",

      user_title: null,
      orders: [],
      table: null,
      overlay_show: false,

      date_range: null,
      start_date: null,
      end_date: null,
    };
  },
  updated() {},
  watch: {
    date_range(newVal, oldVal) {
      // console.log("watch start date");
      // console.log(newVal, oldVal);
      this.start_date = this.date_range[0];
      this.end_date = this.date_range[1];
      // console.log(this.start_date, this.end_date);
      table.draw();
    },
  },
  mounted() {
    console.log("in order history list index mounted");

    let user = JSON.parse(window.localStorage.getItem("user"));
    // console.log(user);
    // console.log(user.id, user.title);
    this.user_id = user.id;
    this.user_title = user.type;
    // this.getOrders(user.id);
    // console.log(this.user_title);
    this.overlay_show = true;
    let temp = this;
    setTimeout(function () {
      temp.initTable();
      //   temp.getOrdersList();
    }, 1000);
  },
  methods: {
    getOrderStatusClassAndStr,
    getOrdersList() {
      console.log("here call user list");
      // console.log(JSON.parse(window.localStorage.getItem("user")).access_token);

      let params_request = "";
      if (this.user_title == "user") {
        params_request = params_request + "&owner_id=" + this.user_id;
      }
      console.log(params_request);

      axios
        .get(
          "/jobs/jobs?is_archived=1&orderBy=id&order=DESC" + params_request,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              client: "DOORDER",
              Authorization:
                "Bearer " +
                JSON.parse(window.localStorage.getItem("user")).access_token,
            },
          }
        )
        .then((response) => {
          // console.log(table);
          // table.destroy();
          if (table != null) {
            table.destroy();
          }
          console.log(response);
          this.orders = response.data.data;
          // console.log(this.rowsData);
          var temp = this;
          setTimeout(function () {
            temp.initTable();
          }, 1000);
          temp.overlay_show = false;
          // table.ajax.reload()
        });
    },
    initTable() {
      let temp = this;
      table = $("#ordersTable").DataTable({
        sDom: 'flti<"table_selected_rows">p',
        ordering: false,
        info: true,
        destroy: true,
        responsive: true,
        // scrollY: "450px",
        scrollCollapse: true,
        searching: true,
        processing: true,
        serverSide: true,
        serverMethod: "get",
        // ajax: {
        //   url: "https://microservices-staging.bumblebeeai.io/api/jobs/jobs",
        //   headers: {
        //     client: "DOORDER",
        //     Authorization:
        //       "Bearer " +
        //       JSON.parse(window.localStorage.getItem("user")).access_token,
        //   },
        // },
        ajax: function (data, callback, settings) {
          console.log(data);
          let page_num = data.start / data.length + 1;
          console.log(page_num);
          // make a regular ajax request using data.start and data.length
          let params =
            "?is_archived=1&orderBy=id&order=DESC&per_page=" +
            data.length +
            "&page=" +
            page_num;

          if (data.search.value != "") {
            params += "&keyword=" + data.search.value;
          }
          if (temp.start_date != null) {
            params += "&start_date=" + temp.start_date;
          }
          if (temp.end_date != null) {
            params += "&end_date=" + temp.end_date;
          }

          if (temp.user_title == "user") {
            params += "&owner_id=" + temp.user_id;
          }

          console.log(params);
          $.get(
            {
              url:
                "https://microservices-staging.bumblebeeai.io/api/jobs/jobs" +
                params,
              headers: {
                client: "DOORDER",
                Authorization:
                  "Bearer " +
                  JSON.parse(window.localStorage.getItem("user")).access_token,
              },
            },
            function (res) {
              console.log(res);
              // map your server's response to the DataTables format and pass it to
              // DataTables' callback
              callback({
                recordsTotal: res.meta.total,
                recordsFiltered: res.meta.total,
                data: res.data,
              });
              // temp.orders = res.data;
              temp.overlay_show = false;
            }
          );
        },
        columns: [
          { data: "created_at", class: "dateTimeTd" },
          { data: "order_id" },
          { data: temp.user_title == "admin" ? "owner.name" : undefined },
          { data: "operator.name" },
          {
            data: "location",
            class: "tablePinTd",
            render: function (data, type, row, meta) {
              var ComponentClass = Vue.extend(RouteLocationPins);
              var instance = new ComponentClass({
                propsData: {
                  order_id: row.order_id,
                  pickup: row.pickup,
                  dropoff: row.location,
                },
              });
              instance.$mount(); // pass nothing

              return instance.$el.outerHTML;
            },
          },
          {
            data: "status",
            render: function (data, type, row, meta) {
              let status = temp.getOrderStatusClassAndStr(row.status);
              var ComponentClass = Vue.extend(ItemStatus);
              var instance = new ComponentClass({
                propsData: {
                  status: status,
                  span_class: "orderStatusSpan " + row.status + "_status",
                },
              });
              instance.$mount(); // pass nothing

              return instance.$el.outerHTML;
            },
          },
          {
            data: "note",
            class: "text-center",
            render: function (data, type, row, meta) {
              var ComponentClass = Vue.extend(Comment);
              var instance = new ComponentClass({
                propsData: {
                  order_id: row.id,
                  comment: row.note,
                },
              });

              instance.$mount(); // pass nothing

              return instance.$el.outerHTML;
            },
          },
          {
            data: "",
            class: "text-center",
            render: function (data, type, row, meta) {
              var ComponentClass = Vue.extend(ViewOrder);
              var instance = new ComponentClass({
                propsData: { order_id: row.id },
              });

              instance.$mount(); // pass nothing

              return instance.$el.outerHTML;
            },
          },
        ],
        lengthMenu: [
          [10, 25, 50, 100],
          [10, 25, 50, 100],
        ],
        columnDefs: [
          {
            targets: -1,
            orderable: false,
          },
          { defaultContent: "N/A", targets: "_all" },
          { visible: temp.user_title == "admin", targets: 2 },
        ],
        select: {
          style: "multi",
        },
        pagingType: "full_numbers",
        language: {
          paginate: {
            previous: "<i class='fas fa-angle-left'></i>",
            next: "<i class='fas fa-angle-right'></i>",
            first: "<i class='fas fa-angle-double-left'></i>",
            last: "<i class='fas fa-angle-double-right'></i>",
          },
          search: "",
          searchPlaceholder: "Search ",
        },
      });

      $("#ordersTable tbody").on("click", "tr", function () {
        let order_id = table.row(this).data().id;
        console.log(order_id);
        temp.clickViewOrderRow(order_id)
      });
    },

    // clickViewOrderRow(id) {
    //   console.log("click order view " + id);
    //   //   e.preventDefault();

    //   //   if (e.target.cellIndex == undefined) {
    //   //   } else {
    //   //     this.$router.push({
    //   //       name: "DoorderRetailerSingleView",
    //   //       params: { id },
    //   //     });
    //   //   }
    // },

    clickViewOrderRow(id) {
      console.log("click order history view " + id);
      this.$router.push({ name: "DoorderViewOrderHistory", params: { id } });
    },
    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date > today;
    },
    clickExport() {
      console.log("click export");
      //   axios
      //     .get("/retailer/accepted-list?export_type=excel", {
      //       headers: {
      //         Accept: "application/json",
      //         "Content-Type": "application/json",
      //         client: "DOORDER",
      //         Authorization:
      //           "Bearer " +
      //           JSON.parse(window.localStorage.getItem("user")).access_token,
      //       },
      //     })
      //     .then((response) => {
      //       console.log(response);
      //       var fileURL = response.data.export_url;
      //       //window.URL.createObjectURL(new Blob([response.data]));
      //       var fileLink = document.createElement("a");

      //       fileLink.href = fileURL;
      //       // fileLink.setAttribute("download", "retailers.xlsx");
      //       document.body.appendChild(fileLink);

      //       fileLink.click();
      //       fileLink.remove();
      //     });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/doorder/orders/lists/History.vue